import React, { useContext } from 'react'
import SettingsContext from './contexts/SettingsProvider';
import DockDisplay from './pages/display/DockDisplay';
import Display from './pages/display/Display';
import { useSettingsService } from './hooks/useSettingsService';
import toast from 'react-hot-toast';

const RootComponent: React.FC = () => {
    const { settings } = useContext(SettingsContext);
    const displayId = new URLSearchParams(window.location.search).get("displayId");

    if (!displayId) {
        toast.error('Display ID not found');
        return <>Display ID not found</>;
    }

    const { fetchSettings } = useSettingsService(displayId);

    React.useEffect(() => {
        fetchSettings();
    }, []);


    if (settings.displayName === 'dock') {
        return <DockDisplay />
    }
    return (
        <Display />
    )
}

export default RootComponent;